const { InMemoryCache } = require('@apollo/client')
const atob = require('atob')

const matchTypename = obj => {
  if (!obj.id) {
    throw new Error(`Object requires an id: ${JSON.stringify(obj)}`)
  }

  return `${atob(obj.id).split(':')[0]}:${obj.id}`
}

module.exports = () => {
  return new InMemoryCache({
    possibleTypes: {
      Node: [
        'Group',
        'AllEvents',
        'Artist',
        'Tag',
        'EventType',
        'WantedListing',
        'TicketAlert',
        'OrganizerProduct',
        'OrganizerShop',
        'Location',
        'City',
        'OrganizerBrand',
        'ActiveEvent',
        'ExpiredEvent',
        'Draft',
        'Conversation',
        'ExternalPrimaryTicketShopAlert',
        'FaqItem',
        'Testimonial',
        'Partner',
        'EventPartner',
        'VoucherListing',
        'OrganizerTicketingOrder',
        'EventQuestionnaire',
      ],
      GroupItem: ['AllEvents', 'ActiveEvent', 'ExpiredEvent', 'Group', 'Artist'],
      Event: ['AllEvents', 'ActiveEvent', 'ExpiredEvent', 'CancelledEvent'],
      User: ['PublicUser', 'Viewer', 'PrivateUser'],
      Listing: ['PublicListing', 'CheckoutListing'],
      CheckoutGenericRow: ['CheckoutTicketRow', 'CheckoutPayoutReversalRow'],
      FanExperience: ['ArtistExperience', 'EventExperience', 'LocationExperience'],
      SearchResultItem: ['EventResult', 'CityResult', 'LocationResult', 'ArtistResult'],
      FeedItem: [
        'ThumbnailEventCollection',
        'ThumbnailWithUrl',
        'ThumbnailBlog',
        'GroupCollection',
        'RecurringEventCollection',
      ],
      CaseMessage: ['SupportMessage', 'UserMessage', 'AutomatedMessage'],
      Error: [
        'BuyerHasBuyerBlockError',
        'CartCurrencyMismatchError',
        'BlockedFromBuyingForEventError',
        'BuyerCanNotBuyTicketsError',
        'BuyerNeedsWantedListingToBuyError',
        'CartLockedError',
        'NoTicketsCouldBeReservedError',
        'NotAllTicketsCouldBeReservedError',
        'TicketsCanOnlyBeBoughtAsSetError',
        'GeneralError',
      ],
    },
    typePolicies: {
      Viewer: { keyFields: matchTypename },
      PrivateUser: { keyFields: matchTypename },
      PublicUser: { keyFields: matchTypename },
      Uri: { merge: true },
      ListingPrice: { merge: true },
      DraftState: { merge: true },
      SellingPriceSuggestion: { merge: true },
      Query: {
        fields: {
          nearby: {
            merge: false,
          },
        },
      },
      Country: {
        keyFields: ['code'],
      },
      DraftTicket: {
        fields: {
          errors: {
            merge: false,
          },
        },
      },
    },
  })
}
